<tm-dialog [open]="dialogOpen$ | async"
           [openFromRight]="true"
           [widthMargin]="panelWidthMargin"
           [width]="panelWidth"
           class="planregistratie-dialog"
           (closeDialog)="closeDialog()"
           [allowCollapse]="true"
           [collapsed]="dialogCollapsed$ | async"
           (expandCollapseDialog)="expandCollapseDialog()"
           [allowFullscreen]="true"
           [dialogTitle]="(dialogTitle$ | async) ?? ''">
  @if (selectedPlan$ | async; as selectedPlan) {
    <div class="form">
      <div class="content">
        <div class="metadata-form">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <strong>{{selectedPlan.planNaam}}</strong>
              </mat-panel-title>
              <mat-panel-description>
                <button (click)="showHelp($event)" mat-icon-button class="help-button">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
                    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" fill="currentColor"/>
                  </svg>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <lib-planregistratie-form [planregistratie]="selectedPlan"
                                      (planregistratieChanged)="planregistratieChanged($event)"></lib-planregistratie-form>
          </mat-expansion-panel>
        </div>
        <div class="details-form">
          <lib-plancategorie-list></lib-plancategorie-list>
        </div>
      </div>
      <div class="buttons">
        @if (isGemeenteGebruiker$ | async) {
          <button (click)="delete(selectedPlan.id)"
                  color="warn"
                  mat-flat-button>Verwijder plan</button>
        }
        <div class="divider"></div>
        @if (isGemeenteGebruiker$ | async) {
          <button (click)="cancel()" mat-flat-button>Annuleren</button>
          <button (click)="save()" [disabled]="(disableSave$ | async) || saving() || savingAndClosing()" color="primary" mat-flat-button>
            @if (saving()) {
                <mat-spinner diameter="20"></mat-spinner>
            } @else {
              Opslaan
            }
          </button>
          <button (click)="save(true)" [disabled]="(disableSave$ | async) || saving() || savingAndClosing()" color="primary" mat-flat-button>
            @if (savingAndClosing()) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              Opslaan & sluiten
            }
          </button>
        } @else {
          <button (click)="cancel()" mat-flat-button>Sluiten</button>
        }
      </div>
    </div>
  }
</tm-dialog>
